import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import { isAluminum, isCopper, isFlexible, isMetal, isRigid } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"

const isValidLayer = (values: EstimateValues, layer?: string) => {
  switch (layer) {
    case ESTIMATE_CONSTANT.構成層数.片面.value:
    case ESTIMATE_CONSTANT.構成層数["2層"].value:
    case ESTIMATE_CONSTANT.構成層数["4層"].value:
    case ESTIMATE_CONSTANT.構成層数["6層"].value:
    case ESTIMATE_CONSTANT.構成層数["8層"].value:
    case ESTIMATE_CONSTANT.構成層数["10層"].value:
    case ESTIMATE_CONSTANT.構成層数["12層"].value:
      return isRigid(values)
    case ESTIMATE_CONSTANT.構成層数.FPC片面.value:
    case ESTIMATE_CONSTANT.構成層数.FPC2層両面.value:
    case ESTIMATE_CONSTANT.構成層数.FPC3層.value:
    case ESTIMATE_CONSTANT.構成層数.FPC4層.value:
      return isFlexible(values)
    case ESTIMATE_CONSTANT.構成層数.片面アルミベース.value:
    case ESTIMATE_CONSTANT.構成層数["2層アルミベース"].value:
    case ESTIMATE_CONSTANT.構成層数["2層アルミコア"].value:
      return isMetal(values) && isAluminum(values)
    case ESTIMATE_CONSTANT.構成層数.片面銅ベース.value:
    case ESTIMATE_CONSTANT.構成層数["2層銅ベース"].value:
    case ESTIMATE_CONSTANT.構成層数["2層銅コア"].value:
    case ESTIMATE_CONSTANT.構成層数.片面銅ベースポスト.value:
    case ESTIMATE_CONSTANT.構成層数["2層銅ベースポスト"].value:
    case ESTIMATE_CONSTANT.構成層数["2層銅コアポスト"].value:
      return isMetal(values) && isCopper(values)
    default:
      return false
  }
}

export default isValidLayer
